import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowRight, FaLayerGroup } from "react-icons/fa";
import bgVideo from "../images/ciits-hero-video.mp4";

function Slider() {
    const navigate = useNavigate();
    const scrollToSection = (id) => (event) => {
        event.preventDefault();
        const section = document.getElementById(id);
        navigate(`/#${id}`);
        if (section) {
            section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    const badges = [
        "Web Development",
        "Mobile Apps",
        "AI Chat Bots",
        "AI Customer Support",
        "Certified IT Experts",
    ];

    return (
        <section className="ciits-hero" role="banner" aria-label="CIITS Hero Section">
            <video className="ciits-hero-video" autoPlay loop muted playsInline>
                <source src={bgVideo} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            <div className="ciits-hero-overlay" />
            <div className="ciits-hero-grid" />

            <div className="ciits-hero-inner">
                <div className="ciits-hero-content">
                    <div className="ciits-hero-kicker">
                        <span className="ciits-hero-kicker-dot" />
                        Central India IT Services
                    </div>

                    <h1>
                        <span className="hero-brand">CIITS</span> – IT &amp; Software Solutions
                    </h1>

                    <p className="ciits-hero-copy">
                        Accelerate your success with cloud, cybersecurity, and custom software solutions for modern businesses.
                    </p>

                    <div className="ciits-hero-actions">
                        <a href="#services" className="ciits-btn ciits-btn--primary" onClick={scrollToSection("services")}>
                            Explore Services <FaArrowRight size={12} />
                        </a>
                        <a href="#products" className="ciits-btn ciits-btn--glass" onClick={scrollToSection("products")}>
                            <FaLayerGroup size={13} /> Our Products
                        </a>
                    </div>

                    <div className="ciits-hero-tags" aria-label="CIITS capabilities">
                        {badges.map((badge) => (
                            <span className="ciits-hero-tag" key={badge}>{badge}</span>
                        ))}
                    </div>
                </div>
            </div>

            <div className="ciits-scroll-cue" aria-hidden="true">
                Scroll
                <span className="ciits-scroll-line" />
            </div>
        </section>
    );
}

export default Slider;
